<template>
<div class="chapter">
<div class="inner_page">
<p class="partno"><a id="page_3"><span class="bb">Part I</span></a></p><a id="page_3">
<p class="pbreak">
</p></a><div class="cap"><a id="page_3">
</a><p class="image"><a id="page_3"></a><a id="page_4"></a><a id="fig3"><img alt="Image" src="images/pg4.jpg"/></a></p><a id="fig3">
<p class="figcaption">Sir Henry Clinton.<br/>Engraving by Alexander H. Ritchie after a painting by John Smart. Author’s collection.</p>
</a></div><a id="fig3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 13_Part01.vue?8f53d63a